<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <Edit :editDialog="editDialog" @close="editDialog = false" @submit="getList" :editTeacher="selectedTeacher"></Edit>

    <AssignStudent :editDialog="assignStudentDialog" @close="assignClose" @submit="getList"
      :editTeacher="selectedTeacher"></AssignStudent>

    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="true" :access="checkRightStatus(21)" title="Teacher" @add="add" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table class="pageHeight" :headers="headers" hide-default-footer
       :items="payees" :search="search" :loading="loading" :sort-by="sortBy"
        :page.sync="page" :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.name }}</td>
            <td>
              <v-chip color="pink" text-color="white" v-if="item.portalAccess">
                <v-icon left>
                  mdi-web
                </v-icon>
                Portal Access
              </v-chip>
            </td>
            <td class="text-left" >
              <div v-if="item.LoginUser">{{ item.LoginUser.email }}</div>
              <div v-else>Not Set</div>
              </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <!-- <v-list-item @click="assignStudentOpen(item)">
                    <v-list-item-title>Assign Student</v-list-item-title>
                  </v-list-item> -->
                  <v-list-item v-if="checkRightStatus(23)"  @click="editTeacher(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item v-if="checkRightStatus(24)" @click="deleteTeacher(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import teacherService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
const AssignStudent = () => import("./AssignStudent");

export default {
  name: "payee-list",
  data() {
    return {
      createDialog: false,
      assignStudentDialog: false,
      editDialog: false,
      selectedTeacher: null,
      headers: [
        {
          text: this.$t("labels.name"),
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
        {
          text: "Login Email",
          align: "left",
          value: "LoginUser.email",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      payees: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "balance",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Teacher List";
  },
  components: {
    Create,
    AssignStudent,
    Edit,
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    assignClose() {
      this.assignStudentDialog = false;
      this.getList();
    },
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      (this.editDialog = false), (this.createDialog = false);
      return teacherService.getAll().then((response) => {
        console.log("response", response);
        this.loading = false;
        this.payees = response.data;
        this.itemsPerPage = this.payees.length
        return response;
      });
    },
    assignStudentOpen(obj) {
      console.log("i got call");
      this.selectedTeacher = obj;
      this.assignStudentDialog = !this.assignStudentDialog;
    },
    editTeacher(obj) {
      this.selectedTeacher = obj;
      this.editDialog = !this.editDialog;
    },
    deleteTeacher(obj) {
      console.log('row', obj)
      this.$swal({
        title: "Are you sure?",
        text: `You want to delete ${obj.name} if so all ${obj.studentCount} will be remove too.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          teacherService.delete(obj.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Teacher has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
